import { render } from "./ClincalOverview.vue?vue&type=template&id=e6dac6b6&ts=true"
import script from "./ClincalOverview.vue?vue&type=script&lang=ts"
export * from "./ClincalOverview.vue?vue&type=script&lang=ts"

import "./ClincalOverview.vue?vue&type=style&index=0&id=e6dac6b6&lang=css"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__